global.constants = {
    city: '宁波',
    cityid: '330200',
    tj_tijian: 'https://tj.tijian.cn',
    www_tijian: 'https://www.tijian.cn',
    u_tijian: 'https://u.tijian.cn',
    api_tj: 'https://api-tj.tijian.cn/',
    api_yg: 'https://api-yg.tijian.cn/',
    api_sso: 'https://api-sso.tijian.cn/',
    api_wx: 'https://wx-token.tijian.cn/',
    wx_tijian: 'https://wx.tijian.cn',
};
global.advertisement = {
    advertisement_wxbanner:'advertisement_wxbanner',//首页banner图
    advertisement_wxmap: 'advertisement_wxmap',    //首页广告图
    advertisement_wxcart: 'advertisement_wxcart',  //购物车广告位
    advertisement_wxreport: 'advertisement_wxreport',    //添加报告广告位
    advertisement_wxinterpret: 'advertisement_wxinterpret',    //报告解读广告位
}